import request from '@/utils/request'

export function employeeItems (params) {
  return request({
    url: '/amrep/employee/items',
    method: 'get',
    params
  })
}

export function employeeCreate (data) {
  return request({
    url: '/amrep/employee/create',
    method: 'post',
    data
  })
}

export function employeeDetails (params) {
  return request({
    url: '/amrep/employee/details/' + params.id,
    method: 'get'
  })
}

export function departmentCreate (data) {
  return request({
    url: '/amrep/employee/createDepartment',
    method: 'post',
    data
  })
}

export function departmentItems () {
  return request({
    url: '/amrep/employee/itemsDep',
    method: 'get'
  })
}

export function depDetails (data) {
  return request({
    url: '/amrep/employee/detailsDep/' + data.id,
    method: 'get',
    params: {
      page: data.page,
      size: data.size
    }
  })
}

export function indexPageInfo () {
  return request({
    url: '/amrep/employee/indexPageInfo',
    method: 'get'
  })
}

export function employeeUpdate (data) {
  return request({
    url: '/amrep/employee/update',
    method: 'put',
    data
  })
}

export function employeeDepHeadEmp (data) {
  return request({
    url: '/amrep/employee/depHeadEmp',
    method: 'post',
    data
  })
}

export function employeeDeparture (data) {
  return request({
    url: '/amrep/employee/departure',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/employee.js